module.exports = __webpack_public_path__ + "static/img/h5-content-bg.fb07ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5-content-bg.png
// module id = pYP9
// module chunks = 0